const API_PROTOCOL =
  process.env.NEXT_PUBLIC_API_SSL === 'true' ? 'https' : 'http'
const SOCKET_PROTOCOL =
  process.env.NEXT_PUBLIC_API_SSL === 'true' ? 'wss' : 'ws'

const API = {
  MAIN_URL: `${API_PROTOCOL}://${process.env.NEXT_PUBLIC_API_MAIN_URL}`,
  MAIN_WS: `${SOCKET_PROTOCOL}://${process.env.NEXT_PUBLIC_API_MAIN_URL}`,
  CHAT_URL: `${API_PROTOCOL}://${process.env.NEXT_PUBLIC_API_CHAT_URL}`,
  CHAT_WS: `${SOCKET_PROTOCOL}://${process.env.NEXT_PUBLIC_API_CHAT_URL}`,
}

const SENTRY = {
  DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
}

const STORE = {
  KEY: process.env.NEXT_PUBLIC_STORE_KEY,
}

const EMAJIN = {
  EVENTS_URL: process.env.NEXT_PUBLIC_EMAJIN_EVENTS_URL,
}

const APP = {
  ORGANIZATION_ID: process.env.NEXT_PUBLIC_ORGANIZATION_ID,
}

const DATOCMS_KEY = process.env.NEXT_PUBLIC_DATOCMS_KEY

const PERSIST_STATE_KEY = `${process.env.NEXT_PUBLIC_STORE_KEY}:store`

const STAGING_AUTH = {
  BASIC_AUTH_USER: process.env.BASIC_AUTH_USER || 'staging',
  BASIC_AUTH_PASS: process.env.BASIC_AUTH_PASS || 'secret',
}

const IS_PRODUCTION = process.env.NEXT_PUBLIC_APP_ENV === 'production'
const IS_STAGING = process.env.NEXT_PUBLIC_APP_ENV === 'staging'

export {
  API,
  APP,
  DATOCMS_KEY,
  EMAJIN,
  IS_PRODUCTION,
  IS_STAGING,
  PERSIST_STATE_KEY,
  SENTRY,
  STAGING_AUTH,
  STORE,
}
